import React, { useEffect, useState } from "react";
import CardComponent from "./CardComponent";
import { deepClone, findGridType, groupOffice } from "../../../../../legacy/utils/helpers";
import "./CardComponent.scss";
import uploadIcon from "../../../../../assets/icons/icon-individualTherapy.svg";

interface Props {
    choices?: Array<any>;
    onChange?: Function;
    className?: string;
    questionMetaData?: any;
}

const RadioCardComponentContainer = ({
    choices,
    onChange,
    className,
    questionMetaData,
}: Props) => {
    const [groupedOffices, setGroupedOffices] = useState({});
    const [isAnySelected, setIsAnySelected] = useState(false);

    const currentChoices = deepClone(choices || []);


    useEffect(() => {
        // Group offices by regionName if isAddressInfoPage is true
        setGroupedOffices(groupOffice(questionMetaData?.metadata?.isAddressInfoPage, currentChoices));
    }, []);

    useEffect(() => {
        // Check if any choice is selected
        setIsAnySelected(currentChoices.some((c: any) => c.selected === true));
    }, [currentChoices]);

    const onChangeSelection = (selected: boolean, choice: any) => {
        const updatedChoices = currentChoices.map((c: any) => {
            if (c.id === choice.id) {
                c.selected = true;
                if (selected) c.value = c.title;
            } else {
                c.selected = false;
                c.value = null;
            }

            return c;
        });

        setGroupedOffices(groupOffice(questionMetaData?.metadata?.isAddressInfoPage,currentChoices));
        onChange(updatedChoices);
    };

   return (
       <div className={` row ${className}`}>
           {Object.entries(groupedOffices).map(([region, offices]) => (
               <div className="text-center mt-4" key={region}>
                   {region && <h2>{region}</h2>}
                   <div
                       className={`grid-container card-component-container layout-grid-${findGridType(offices.length)} ${
                           questionMetaData?.metadata?.isAddressInfoPage
                               ? "address-grid"
                               : ""
                       }`}
                   >
                       {offices.map((office: any) => (
                           <CardComponent
                               key={office.unique_key}
                               isAnySelected={isAnySelected}
                               selected={office.selected}
                               onChange={(selected: boolean) =>
                                   onChangeSelection(selected, office)
                               }
                               color={"orange"}
                               choice={office}
                               icon={uploadIcon}
                               isAddressInfoPage={
                                   questionMetaData?.metadata?.isAddressInfoPage
                               }
                           />
                       ))}
                   </div>
               </div>
           ))}
       </div>
   );
};

export default RadioCardComponentContainer;
